import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const fetchPaymentTerms = () => {
  return axios.get(`${apiurl?.getPaymentTerms}`);
};

const getPaymentTerms = () => {
  return useQuery(['getPaymentTerms'], fetchPaymentTerms, { refetchOnWindowFocus: false });
};

export default getPaymentTerms;
